function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Invisible",
  transform: "translate(0 -3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1279",
  "data-name": "Group 1279",
  transform: "translate(0 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_821",
  "data-name": "Path 821",
  d: "M9,15.407A4.308,4.308,0,0,1,8.7,13.826a4.353,4.353,0,0,1,4.348-4.348,4.308,4.308,0,0,1,1.581.308l2.943-2.943A12.89,12.89,0,0,0,13.043,6C6.336,6,.35,13.243.1,13.551a.435.435,0,0,0,0,.55,27.759,27.759,0,0,0,5.369,4.843Z",
  transform: "translate(-0.001 -3.391)",
  fill: "#898989"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_822",
  "data-name": "Path 822",
  d: "M26.536,13.193a20.27,20.27,0,0,0-6.347-5.767l3.684-3.684a.435.435,0,0,0-.615-.615L4.128,22.257a.435.435,0,0,0,0,.615A.431.431,0,0,0,4.435,23a.437.437,0,0,0,.308-.127L7.91,19.705a12.306,12.306,0,0,0,5.655,1.556c6.708,0,12.695-7.243,12.946-7.551A.436.436,0,0,0,26.536,13.193Zm-12.97,4.59a4.305,4.305,0,0,1-2.736-1L16.916,10.7a4.305,4.305,0,0,1,1,2.736A4.353,4.353,0,0,1,13.565,17.782Z",
  transform: "translate(-0.522 -3)",
  fill: "#898989"
})));

var SvgInvisible = function SvgInvisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.086,
    height: 20,
    viewBox: "0 0 26.086 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Invisible.e58b16bb.svg";
export { ForwardRef as ReactComponent };